var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 21.531,
    viewBox: "0 0 20.5 21.531",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Packages",
    transform: "translate(-0.25 -0.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10280",
    "data-name": "Path 10280",
    d: "M11.345,1.435l7.6,3.716A1.854,1.854,0,0,1,20,6.814v8.853a1.854,1.854,0,0,1-1.054,1.663l-7.6,3.716a1.939,1.939,0,0,1-1.7,0l-7.6-3.716A1.854,1.854,0,0,1,1,15.657V6.814A1.854,1.854,0,0,1,2.054,5.151l7.6-3.716a1.939,1.939,0,0,1,1.691,0Z",
    transform: "translate(0)",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10281",
    "data-name": "Path 10281",
    d: "M1.32,5.971l9.2,4.5,9.2-4.5m-9.2,15.42V10.467M5.766,3.5l9.5,4.645",
    transform: "translate(-0.016 -0.161)",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackages);
export default __webpack_public_path__ + "static/media/Packages.72c034c6169f43167c0655fb9e2e3d8c.svg";
export { ForwardRef as ReactComponent };